import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from '../../../core';
import { Nota } from '../nota';

@Component({
    selector: 'sgt-nota-form-insert',
    templateUrl: './nota-form-insert.component.html',
    styleUrls: ['./nota-form-insert.component.less']
})
export class NotaFormInsertComponent implements OnInit {
    isInserting = false;
    nota: Nota;

    // Referências
    /** ID do lead vinculado a nota */
    @Input() idLead: number = null;
    /** ID do cliente vinculado a nota */
    @Input() idCliente: number = null;
    /** ID do negócio vinculado a nota */
    @Input() idNegocio: number = null;
    /** ID do título a receber vinculado a nota */
    @Input() idTituloReceber: number = null;

    /** Envia o evento para inserir a nova nota */
    @Output() insert = new EventEmitter<Nota>();

    @ViewChild('form') form: NgForm;

    constructor(private authService: AuthService) { }

    ngOnInit(): void {
        this.create();
    }

    private create() {
        this.nota = new Nota(this.authService.getIdEmpresa());
        // Referências
        this.nota.idLead = this.idLead;
        this.nota.idCliente = this.idCliente;
        this.nota.idNegocio = this.idNegocio;
        this.nota.idTituloReceber = this.idTituloReceber;
    }

    /** Verifica se está inserindo uma nota válida */
    isInsertingValid() {
        return this.isInserting && !this.form.invalid;
    }

    insertClick() {
        this.isInserting = true;
        this.create();
    }

    emitInsert() {
        this.insert.emit(this.nota);
        this.cancel();
    }

    cancel() {
        this.isInserting = false;
        this.nota = null;
    }
}
